// @flow

import * as React from 'react';
import classNames from 'classnames';

import Tooltip from '../../common/components/core/Tooltip';
import PasswordShowHide from './PasswordShowHide';

import type { TitleProps } from '../../common/types/titleTypes';

type Props = {
  /**
   * This prop is passed from AuthInput.jsx and toggles the display of the Show/Hide icon next to the title.
   */
  displayShowHide?: boolean,
  /**
   * This prop is passed through this component from Input.jsx to PasswordShowHide.jsx
   * It is called from the PasswordShowHide component to toggle state in the Input component.
   */
  onShowHide?: () => void,
  /**
   * This prop is passed through this component from Input.jsx to PasswordShowHide.jsx
   * It is used to toggle the show password feature.
   */
  showPassword?: ?boolean
} & TitleProps;

class AuthTitle extends React.PureComponent<Props> {
  renderLabel = () => {
    const props = this.props;

    if (props.hoverableTooltip) {
      return (
        <label className={classNames('h_mend-5 h_mb-0', props.labelClassName)}>
          <Tooltip body={props.hoverableTooltip}>{props.label}</Tooltip>
        </label>
      );
    }

    return (
      <div className="title-container">
        <label className={classNames('h_mend-5 h_mb-0', props.labelClassName)}>
          {props.label}
        </label>
        {props.tooltip && <Tooltip body={props.tooltip} />}
        {!!props.displayShowHide ? (
          <PasswordShowHide
            onShowHide={this.props.onShowHide}
            showPassword={this.props.showPassword}
          />
        ) : null}
      </div>
    );
  };

  render() {
    const props = this.props;
    if (!props.label) {
      return null;
    }

    return (
      <div className="h_mb-5" data-testid="title">
        {this.renderLabel()}
        {props.description && (
          <div className="label__description" data-testid="description">
            {props.description}
          </div>
        )}
      </div>
    );
  }
}

export default AuthTitle;
